import Backbone from 'backbone';
import dust from 'dustjs';
import { GBISimilarSearchesModel } from 'models/store/client/gbi/gbi_similar_searches';
import RelatedQueriesTemplate from 'store/global/pages/categories/_relatedQueries.dust';
import { searchSource } from 'lib/enums';

export const GBISimilarSearchesView = Backbone.View.extend({
	initialize: function(options) {
		const { query = '' } = options || {};
		this.gbiSimilarSearchesModel = new GBISimilarSearchesModel({ query });
	},

	setSearchTerm: function(term) {
		this.gbiSimilarSearchesModel.setSearchTerm(term);
	},

	fetch: function() {
		return this.gbiSimilarSearchesModel
			.fetch()
			.then(() => this.render())
			.catch((error) => {
				window.clientErrorHandler(error);
			});
	},

	renderSimilarSearches: function() {
		return new Promise((resolve, reject) => {
			const data = this.gbiSimilarSearchesModel.get('results');
			if (!data || !data.relatedQueries || !data.relatedQueries.length) {
				resolve(null);
				return;
			}
			const results = {
				relatedQueries: data.relatedQueries.slice(0, 10).map((queryData) => queryData.query)
			};
			dust.render(RelatedQueriesTemplate, { results, source: searchSource.SIMILAR_QUERIES }, (err, out) => {
				if (err) {
					reject(err);
				} else {
					resolve(out);
				}
			});
		});
	},

	render: function() {
		return this.renderSimilarSearches()
			.then((out) => {
				if (out) {
					this.$el.html($(out));
				}
			})
			.catch((error) => {
				window.clientErrorHandler(error);
			});
	}
});
